<script>
import httpService from '@/core/api/request'
export default {
  data: function () {
    return {
      colors: null,
      sizes: null
    }
  },
  methods: {
    getColors: function () {
      this.getAttributes(1)
        .then(
          colors => {
            this.colors = colors
          }
        )
    },
    getSizes: function () {
      this.getAttributes(2)
        .then(
          sizes => {
            this.sizes = sizes
          }
        )
    },
    getAttributes: function (attr_type) {
      return new Promise(resolve => {
        let httpRequest = {
          module: 'attributes',
          params: '?type_id=eq:' + attr_type
        }
        this.get(httpRequest)
          .then(
            attrs => {
              resolve(attrs.data)
            }
          ).catch(
            () => {
              resolve([])
            } 
          )
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/inventory/mixins.vue